export default __webpack_public_path__ + "static/media/suport_agent.9a24c972.svg";